import { Container, Divider, Heading } from "@chakra-ui/react";
import CardForm from "components/ui/CardForm";
import HeaderBarInternal from "components/ui/HeaderBarInternal";
import { useResource } from "hooks/useResource";
import { useParams } from "react-router-dom";
import TagForm from "../components/TagForm";

export default function PageEditTag() {
  const { id, type } = useParams();
  const { data: tag } = useResource({
    id: id as string,
    resourceName: "tag",
    path: `tags/${type}`,
  });

  return (
    <>
      <HeaderBarInternal title="Editar tag" backTo={`/tags/${type}`} />
      <Divider />

      <Container variant="internal" flexDirection="column">
        <Heading as="h1" size="h1">
          Dados da tag
          <span>Edite os dados da tag</span>
        </Heading>

        <CardForm>
          {tag && <TagForm tag={tag} type={type as string} />}
        </CardForm>
      </Container>
    </>
  );
}
